import request from '@/utils/request'

export function getDownUrl() {
    return request.post('/index/other/get_down_url');
}
//新增获取配置接口
export function getConfig() {
    // off_url官网地址
    // qq客服qq
    // buy_url购买地址列表 数组中time可以方便用来计算充值后到期时间
    return request.post('/index/other/get_config');
}

//新增获取广告
export function getAds() {
    // title                标题
    //ad_img          广告图片地址
    //adx_img        "X"图标地址
    //ad_url            广告跳转地址
    return request.post('/index/other/get_ads');
}
//获取 usdt 的支付跳转地址
export function getPayUrl(user_id,amount) {
    // user_id 用户id
    // amount 支付金
    //{"code":200,"msg":"获取成功","data":"https://pay.metarsier.com/invoice/xxxxxxxx"}
    //return request.post('/index/other/get_pay_url');
    // return request.post('/index/other/get_pay_url',{
    //     user_id: user_id,
    //     amount: amount
    // });
    return request.get('/index/other/get_pay_url',{
        params: {
            user_id: user_id,
            amount: amount
        }
    });
}

/**
 * 获取订单列表接口
 * @param {*} user_id 
 * type字段 1.宝转卡 2.usdt 不传时默认1
 * @returns 
 */
export function getOrderList(user_id,type = 1) {
    //status 2 未支付 3已支付 4已取消
    return request.get('/index/other/get_order_list',{
        params: {
            user_id: user_id,
            type: type
        }
    });
}

/**
 * 取消订单接口
 * @param {*} user_id 
 * @param {*} order_id  不传order_id取消当前用户所有订单
 * type字段 1.宝转卡 2.usdt 不传时默认1
 * @returns 
 */
export function getClearOrder(user_id,order_id = '',type = 1) {
    //status 2 未支付 3已支付 4已取消
    return request.get('/index/other/clear_order',{
        params: {
            user_id: user_id,
            order_id: order_id,
            type: type
        }
    });
}


//获取 usdt 的支付跳转地址
export function getBzyPayUrl(user_id,amount) {
    // user_id 用户id
    // amount 支付金
    return request.get('/index/other/get_bzk_pay_url',{
        params: {
            user_id: user_id,
            amount: amount
        }
    });
}

//获取 usdt 的支付跳转地址
export function getUsdtPayUrl(user_id,amount) {
    // user_id 用户id
    // amount 支付金
    return request.get('/index/other/get_usdt_pay_url',{
        params: {
            user_id: user_id,
            amount: amount
        }
    });
}


// WEBPACK FOOTER //
// ./src/api/config.js